import {axiosInstance} from "../../../../hoc/Axios/Axios";
import * as actionTypes  from "../../../Actions";

export const sendResetLink = user => dispatch => axiosInstance
    .post("/auth/password/email", user, { headers: { "Accept-Language": user.lang } })
    .then(response => {
        dispatch({ type: actionTypes.SEND_RESET_PASSWORD_SUCCESS, payload: response.data.data })
    })
    .catch(() => null);
